import React from "react";

import Breadcrumbs from "~/components/Breadcrumbs";

import useArticleBreadcrumbs from "~/hooks/breadcrumbs/useArticleBreadcrumbs";

const NewsArticleBreadcrumbs = ({ data }) => {
    const {
        wpNewsArticle: {
            title,
            articleOptions: { breadcrumbsAtTop },
        },
    } = data;

    const breadcrumbs = useArticleBreadcrumbs(title, "newsBase", "News");

    return (
        <Breadcrumbs
            backgroundColor={breadcrumbsAtTop ? "gray" : "white"}
            crumbs={breadcrumbs}
            noMarginBottom={breadcrumbsAtTop}
        />
    );
};

export default NewsArticleBreadcrumbs;
